// Schönecke: Anzahlung 30 € einmal pro Bestellung (Beschluss Call 12.10.2026).
// Die Produkte kosten 0 €; der Artikel "Anzahlung Vorbestellung" (Produkt-Handle "anzahlung", WinWeb-Art.-Nr. 109970) wird automatisch
// genau einmal in den Warenkorb gelegt, sobald dort ein anderer Artikel liegt, und entfernt, wenn
// der Warenkorb sonst leer ist. Menge/Löschen sind für die Position im Warenkorb ausgeblendet
// (snippets/cart-products.liquid). Den Checkout sperrt abholung-picker.js, solange
// window.__schoeneckeAnzahlungOk === false ist.
import { StandardEvents, CartLinesUpdateEvent } from '@shopify/events';

const ANZAHLUNG_ID = Number(window.SCHOENECKE_ANZAHLUNG_VARIANT || 0);
const QUELLE = 'schoenecke-anzahlung';
let laeuft = null;

function sectionIds() {
  return [...document.querySelectorAll('cart-items-component')]
    .map((el) => el.dataset.sectionId)
    .filter(Boolean);
}

async function post(url, body) {
  const ids = sectionIds();
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ ...body, ...(ids.length ? { sections: ids.join(','), sections_url: location.pathname } : {}) }),
  });
  if (!res.ok) throw new Error(`Warenkorb-Aktualisierung fehlgeschlagen (${res.status})`);
  return res.json();
}

// Horizon (Warenkorb-Schublade, Warenkorbseite, Warenkorb-Symbol) über die Änderung informieren
function melden(antwort) {
  const cart = antwort.items ? antwort : null;
  const promise = Promise.resolve({
    cart: cart ? CartLinesUpdateEvent.createCartFromAjaxResponse(cart) : null,
    detail: { sections: antwort.sections, items: antwort.items, itemCount: cart?.item_count, source: QUELLE },
  });
  document.dispatchEvent(new CartLinesUpdateEvent({ action: 'update', lines: [], promise }));
}

async function abgleichen() {
  if (!ANZAHLUNG_ID) return;
  const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
  const anz = cart.items.filter((i) => i.variant_id === ANZAHLUNG_ID);
  const andere = cart.items.filter((i) => i.variant_id !== ANZAHLUNG_ID);
  const menge = anz.reduce((s, i) => s + i.quantity, 0);

  let antwort = null;
  if (andere.length && menge === 0) {
    await post('/cart/add.js', { items: [{ id: ANZAHLUNG_ID, quantity: 1 }] });
    antwort = await post('/cart/update.js', {}); // liefert kompletten Warenkorb + Sections
  } else if (andere.length && menge !== 1) {
    antwort = await post('/cart/change.js', { id: anz[0].key, quantity: 1 });
    for (const extra of anz.slice(1)) antwort = await post('/cart/change.js', { id: extra.key, quantity: 0 });
  } else if (!andere.length && menge > 0) {
    for (const a of anz) antwort = await post('/cart/change.js', { id: a.key, quantity: 0 });
  }

  window.__schoeneckeAnzahlungOk = true;
  if (antwort) melden(antwort);
}

function anstossen() {
  window.__schoeneckeAnzahlungOk = false;
  laeuft = (laeuft || Promise.resolve())
    .then(abgleichen)
    .catch((e) => {
      console.warn('[schoenecke-anzahlung]', e);
      window.__schoeneckeAnzahlungOk = false;
    });
  return laeuft;
}

if (!window.__schoeneckeAnzahlungInit) {
  window.__schoeneckeAnzahlungInit = true;
  window.schoeneckeAnzahlungAbgleichen = anstossen;

  // Nach jeder Warenkorb-Änderung durch das Theme (hinzufügen, Menge, löschen)
  document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
    if (event.detail?.source === QUELLE) return;
    Promise.resolve(event.promise)
      .then((r) => {
        if (r?.detail?.source !== QUELLE) anstossen();
      })
      .catch(() => anstossen());
  });

  // Beim Seitenaufruf (z. B. Warenkorb aus früherer Sitzung)
  anstossen();
}
